'use client';

import { useTranslations } from 'next-intl';
import { getViduAbilityDetail } from './getAbilityData';
import { ViduAbilityItem } from './ViduAbilityItem';

export const ViduAbility = () => {
  const t = useTranslations('home3.viduAbility');

  const abilityItems = getViduAbilityDetail(t);

  return (
    <>
      {abilityItems.map((item) => {
        const { key, ...rest } = item;
        return <ViduAbilityItem key={`ability-${key}`} {...rest} />;
      })}
    </>
  );
};
